export const FullModelToggledOnIcon = ({
  className,
  color = '#1E1E1E',
}: {
  className?: string
  color?: string
}) => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.724138 14.754V4.27805C0.724138 3.76777 1.01118 3.29787 1.47336 3.05157L5.55943 0.874014C6.00404 0.637073 6.54449 0.642531 6.98388 0.8884L16.6564 6.30084C17.1038 6.55118 17.3793 7.01311 17.3793 7.51293V17.7126C17.3793 18.2229 17.0923 18.6928 16.6301 18.9391L12.5266 21.1259C12.0915 21.3579 11.5637 21.3579 11.1285 21.1259L1.47336 15.9805C1.01118 15.7342 0.724138 15.2643 0.724138 14.754Z"
        fill="white"
      />
      <path
        d="M0 14.7542V4.27772C0.000123808 3.51246 0.430579 2.80772 1.12369 2.4383L5.20969 0.261091C5.8766 -0.0943201 6.68766 -0.086516 7.34675 0.282289L17.0194 5.69455C17.6904 6.07004 18.1034 6.76313 18.1034 7.51277V17.713C18.1033 18.4782 17.6729 19.183 16.9798 19.5524L12.8761 21.7392C12.2234 22.087 11.432 22.0869 10.7793 21.7392L1.12369 16.5936C0.430571 16.2241 6.3096e-05 15.5195 0 14.7542ZM1.44828 14.7542C1.44834 15.0093 1.59204 15.2444 1.82307 15.3676L11.478 20.5124C11.6956 20.6284 11.9598 20.6284 12.1774 20.5124L16.2804 18.3257C16.5114 18.2026 16.655 17.968 16.6552 17.713V7.51277C16.6551 7.26295 16.5174 7.03208 16.2938 6.90692L6.62119 1.49466C6.40154 1.37175 6.13136 1.36874 5.90908 1.48714L1.82307 3.66504C1.59208 3.78814 1.4484 4.02271 1.44828 4.27772V14.7542Z"
        fill={color}
      />
      <path
        d="M11.2418 4.23943L6.53492 7.04026L5.77542 5.84772L10.4823 3.04688L11.2418 4.23943Z"
        fill={color}
      />
      <path
        d="M5.43103 11.6491V6.84059L0.351461 3.89342L1.09681 2.69268L6.17639 5.63984C6.61245 5.89296 6.87931 6.34878 6.87931 6.84059V11.6491L11.6003 14.3884C12.044 14.6459 12.3121 15.1127 12.3033 15.613L12.1986 21.5108L10.751 21.4862L10.855 15.5891L6.13396 12.8498C5.69789 12.5967 5.43103 12.1409 5.43103 11.6491Z"
        fill={color}
      />
      <path
        d="M17.6339 13.7517L11.8408 15.8524L11.3316 14.5408L17.1247 12.4402L17.6339 13.7517Z"
        fill={color}
      />
      <path
        d="M9.39536 4.5592L13.2948 2.30739C13.7392 2.05075 14.2915 2.04298 14.7435 2.28701L19.5337 4.87339C19.9919 5.12081 20.2759 5.5886 20.2759 6.09611V10.6044C20.2759 11.1097 19.9943 11.5759 19.5391 11.8241L15.3657 14.1002C14.9161 14.3455 14.3654 14.3407 13.9204 14.0878L9.40405 11.5209C8.96145 11.2694 8.68966 10.81 8.68966 10.3136V5.76153C8.68966 5.26859 8.95768 4.81194 9.39536 4.5592Z"
        fill="#D9D9D9"
      />
      <path
        d="M7.96552 10.3136V5.76156C7.96552 5.02215 8.36763 4.33682 9.02414 3.9577L12.9235 1.70596C13.5901 1.32104 14.4187 1.30985 15.0966 1.67587L19.8869 4.26199C20.5742 4.63312 20.9999 5.3348 21 6.09594V10.6042C21 11.3622 20.5775 12.0617 19.8947 12.4341L15.7217 14.7104C15.0472 15.0783 14.2211 15.0707 13.5535 14.6913L9.03687 12.1243C8.37315 11.7469 7.96552 11.0581 7.96552 10.3136ZM9.41379 10.3136C9.41379 10.5618 9.54961 10.7916 9.77091 10.9174L14.2876 13.4844C14.5101 13.6107 14.7856 13.6131 15.0103 13.4905L19.1833 11.2142C19.4109 11.09 19.5517 10.8569 19.5517 10.6042V6.09594C19.5517 5.84225 19.4095 5.60831 19.1805 5.48462L14.3901 2.8985C14.1642 2.77658 13.8881 2.78047 13.666 2.90876L9.76667 5.1605C9.54786 5.28688 9.41379 5.51511 9.41379 5.76156V10.3136Z"
        fill={color}
      />
      <path
        d="M8.65147 11.2716L6.47905 12.3219L5.83129 11.0692L8.0037 10.0189L8.65147 11.2716Z"
        fill={color}
      />
      <path
        d="M14.8349 7.19822L14.4828 7.81022H15.0952V13.7962H13.6469V8.16101L8.33749 5.30547L9.04182 4.08147L14.8349 7.19822Z"
        fill={color}
      />
      <path
        d="M20.5997 5.66993L14.8066 8.47077L14.1589 7.21805L19.952 4.41721L20.5997 5.66993Z"
        fill={color}
      />
    </svg>
  )
}
